import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core/styles";
import {TextField} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import BoldTypography from "components/BoldTypography";
import GridBlock from "components/GridBlock";
import IconButton from "components/button/IconButton";
import WorkableIconButton from "components/button/WorkableIconButton";
import SimpleSelect from "components/SimpleSelect";
import {OfferEvaluationRoundType, OfferEvaluationRoundTypeLabel} from "../constants/OfferEvaluationRoundType";
import ViewMode from "../constants/OfferEvaluationViewMode";
import {useDidUpdateEffect} from "../../../../../../../../hooks/useDidUpdateEffect";

const useStyle = makeStyles(theme => ({
    root: {
        marginBottom: theme.spacing(2),
        '&>*:not(:first-child):not(:last-child)': {
            marginLeft: theme.spacing(4),
        }
    },
    roundType: {
        width: 285,
    },
    search: {
        width: 250,
    }
}));

const EMPTY_SEARCH_OBJECT = {roundType: OfferEvaluationRoundType.BASE, search: ''}
const MAX_SEARCH_LENGTH = 100;

const decisionsList =
    [OfferEvaluationRoundType.BASE, OfferEvaluationRoundType.ADDITIONAL_OFFERS, OfferEvaluationRoundType.AUCTION].map(key => ({
        label: OfferEvaluationRoundTypeLabel(key),
        value: key
    }))

function OfferEvaluationSearch(
    {
        searchInProgress,
        doSearch,
        viewMode
    }) {

    const classes = useStyle();
    const [value, setValue] = useState({...EMPTY_SEARCH_OBJECT});
    const [submitState, setSubmitState] = useState({counter: 0, paginationClear:true});

    useEffect(() => {
        if (submitState && !searchInProgress) {
            const valueFiltered = Object.keys(value)
                .filter((k) => value[k])
                .reduce((a, k) => ({...a, [k]: value[k]}), {});
            doSearch(valueFiltered, submitState.paginationClear);
        }
        // eslint-disable-next-line
    }, [submitState]);

    useDidUpdateEffect(()=> {
        doClearSearch();
    }, [viewMode]);


    const handleChange = (id, e) => {
        setValue({...value, [id]: e.target.value});
    }

    const handleSubmit = (paginationClear=true) => {
        setSubmitState(x => ({counter: x.counter + 1,  paginationClear}))
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmit()
        }
    }

    const doClearSearch = () => {
        setValue({...value, search: ""});
        handleSubmit();
    }

    return (
        <>
            <BoldTypography>{Tr('search_box')}</BoldTypography>
            <GridBlock
                alignItems='flex-end'
                className={classes.root}
            >
                <SimpleSelect
                    className={classes.roundType}
                    label={Tr('offer_evaluation_round_type')}
                    items={decisionsList}
                    value={value.roundType}
                    onChange={(e) => {
                        handleChange("roundType", e);
                        handleSubmit(false);
                    }}
                />

                <TextField
                    className={classes.search}
                    label={Tr(viewMode === ViewMode.POSITION ? "search_part" : "search_supplier")}
                    onChange={e => handleChange('search', e)}
                    onKeyUp={handleKeyPress}
                    fullWidth
                    value={value.search}
                    inputProps={{maxLength: MAX_SEARCH_LENGTH}}
                />

                <div>
                    <WorkableIconButton Icon={SearchIcon} working={searchInProgress} onClick={handleSubmit} tooltip={Tr('search')}/>
                    <IconButton disabled={searchInProgress} Icon={ClearIcon} tooltip={Tr('clear')} onClick={doClearSearch}/>
                </div>
            </GridBlock>
        </>
    )
}

OfferEvaluationSearch.propTypes = {
    doSearch: PropTypes.func.isRequired,
    searchInProgress: PropTypes.bool,
    viewMode: PropTypes.oneOf([ViewMode.POSITION, ViewMode.SUPPLIER]).isRequired
}


export default OfferEvaluationSearch;